module.exports = __webpack_public_path__ + "img/camera.6ea04fe1.svg";